import React from 'react';
import { experiences } from '../../data/constants';
import useReveal from '../../hooks/useReveal';
import './styles.css';

export default function Experience() {
  const ref = useReveal();

  return (
    <section className="section" id="experience" ref={ref}>
      <p className="section-label reveal">Experience</p>
      <h2 className="section-title reveal reveal-delay-1">Where I've Worked</h2>

      <div className="exp__list">
        {experiences.map((exp, i) => (
          <div className="exp__card reveal reveal-delay-2" key={i}>
            <div className="exp__header">
              <div>
                <h3 className="exp__role">{exp.role}</h3>
                <span className="exp__company">{exp.company}</span>
              </div>
              <span className="exp__date">{exp.date}</span>
            </div>

            <ul className="exp__points">
              {exp.points.map((point, j) => (
                <li className="exp__point" key={j}>{point}</li>
              ))}
            </ul>

            <div className="exp__tech">
              {exp.tech.map((t, j) => (
                <span className="exp__tag" key={j}>{t}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
